export default "__VITE_ASSET__Bsm4KwUH__"